<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <h4 class="font-weight-bold">Aspectos e Situação Familiar</h4>
            </div>
        </div>
        <b-tabs content-class="mt-3">
            <b-tab title="Situação Familiar" active>
                <div class="row">
                    <form-select
                        v-model="aspecto.vinculacao_afetiva_positiva"
                        :itens="$root.arrays.pergunta"
                        label="Possui família natural, com vinculação afetiva positiva?"
                    />
                    <form-select
                        v-model="aspecto.dados_familia_natual"
                        :itens="$root.arrays.pergunta"
                        label="Dispõe de dados sobre a família natural?"
                    />
                    <form-select
                        v-model="
                            aspecto.familia_natural_sem_vinculacao_afetiva_positiva
                        "
                        :itens="$root.arrays.pergunta"
                        label="Possui família natural, mas não apresenta vinculação afetiva positiva?"
                    />

                    <form-select
                        v-model="aspecto.impedimento_judicial"
                        :itens="$root.arrays.pergunta"
                        label="Há impedimento judicial para contato com a família natural?"
                    />
                    <form-select
                        v-model="aspecto.situacao_orfandade"
                        :itens="$root.arrays.pergunta"
                        label="Está em situação de orfandade?"
                    />
                </div>
            </b-tab>
            <b-tab title="Aspectos Sociofamiliares">
                <div class="row">
                    <form-select
                        v-model="aspecto.avaliacao_vinculo"
                        :itens="$root.arrays.avaliacao_vinculo"
                        label="Avaliação sobre os vínculos familiares?"
                    />
                    <form-select
                        v-model="aspecto.respeita_regra_responsaveis"
                        :itens="$root.arrays.pergunta"
                        label="Respeita as regras estabelecidas pelos genitores/responsáveis?"
                        :disabled="disabledFromOsasco()"
                    />
                    <form-select
                        grid="6"
                        v-model="aspecto.chega_tarde_casa"
                        :itens="$root.arrays.pergunta"
                        label="Chega tarde da noite em casa?"
                        :disabled="disabledFromOsasco()"
                    />
                    <form-select
                        grid="6"
                        v-model="aspecto.tempo_na_rua"
                        :itens="$root.arrays.tempo_na_rua"
                        label="Quanto tempo passa na rua?"
                    />
                    <form-select
                        grid="6"
                        v-model="aspecto.tabela_horario"
                        :itens="$root.arrays.pergunta"
                        label="Necessidade de Tabela de Horários?"
                        :disabled="disabledFromOsasco()"
                    />
                    <form-textarea-editor
                        v-model="aspecto.observacoes"
                        label="Observação sobre outros vínculos afetivos fora do grupo familiar e participação de grupos sociais"
                    />
                </div>
            </b-tab>
        </b-tabs>

        <div class="row pt-2 px-2 d-flex justify-content-end">
            <button @click="submit" class="btn btn-success btn-submit">
                <i class="mdi mdi-content-save"></i>
                Salvar
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            aspecto: {},
        };
    },
    mounted() {
        if (this.item.aspecto != null) {
            this.aspecto = this.item.aspecto;
        }
    },
    methods: {
        disabledFromOsasco() {
            //
            if (window.location.hostname == "osascosp.suasfacil.com.br") {
                return true;
            } else {
                return false;
            }
        },
        submit() {
            this.item.aspecto = this.aspecto;
            this.$emit("submit");
        },
    },
};
</script>
